<template>
    <b-card no-body class="overflow-hidden">
        <b-row>
            <b-col>
                <b-img
                    class="image1"
                    src="https://i.imgur.com/WpFuCvl.jpg"
                />
            </b-col>
        </b-row>
        <b-row class="my-2 mx-0 text-muted">
            <b-col>
                <b-icon class="mr-2" icon="hand-thumbs-up" />
                <span>1 Like</span>
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>
.image1 {
    width: 100%;
    height: 220px;
    object-fit: cover;
}
</style>

<script>
export default {
    
}
</script>